import { render, staticRenderFns } from "./meta.vue?vue&type=template&id=115b3503&"
import script from "./meta.vue?vue&type=script&lang=js&"
export * from "./meta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports